/**
 * Admin UID allowlist for destructive operations.
 *
 * Only users whose `uid` appears in this array can access the
 * "Delete User Docs" admin panel. Keep this list as short as possible.
 *
 * To authorize an admin, add their Firebase Auth UID as a string below.
 *
 * NOTE: This is a client-side gate only — it is not a security boundary.
 * Firestore security rules and backend checks must still enforce
 * authorization server-side. This list exists to prevent accidental
 * access via the admin UI.
 */
export const ADMIN_UIDS_DELETE_USER: readonly string[] = [
  // TODO: add authorized admin UIDs, e.g. "abc123YourAdminUid"
  "oETFx54rtlWk0QafyT9T4nYRQa23"
];

/** Returns true if the given uid is in the delete-user admin allowlist. */
export const isDeleteUserAdmin = (uid: string | undefined | null): boolean => {
  if (!uid) return false;
  return ADMIN_UIDS_DELETE_USER.includes(uid);
};
